export const environment = {
  production: true,
  STATUS_TRACKER_API_URL: '##{STATUS_TRACKER_BASE_API_URL}##',
  LOCALIZATION_API_URL: '##{LOCALIZATION_API_BASE_URL}##',
  LogoUrlLink: '##{LogoUrlLink}##',
  GoogleKey: '##{GoogleKey}##',
  PUSH_NOTIFICATION_API_URI: '##{PUSH_NOTIFICATION_API_URI}##',
  ColorCode: '##{EncryptionKey}##',
  Tracker_CookieScript_Key: '##{Tracker_CookieScript_Key}##',
};